import { render, staticRenderFns } from "./WidgetWrapper.vue?vue&type=template&id=bd3d33f2&scoped=true&"
import script from "./WidgetWrapper.vue?vue&type=script&lang=js&"
export * from "./WidgetWrapper.vue?vue&type=script&lang=js&"
import style0 from "./WidgetWrapper.vue?vue&type=style&index=0&id=bd3d33f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3d33f2",
  null
  
)

export default component.exports